import { render, staticRenderFns } from "./DrivingLicenceFront.vue?vue&type=template&id=5bd521c5&scoped=true"
var script = {}
import style0 from "./DrivingLicenceFront.vue?vue&type=style&index=0&id=5bd521c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd521c5",
  null
  
)

export default component.exports